import React from "react";
import { Route, Switch } from "react-router-dom";
import Authorities from "../../../auth/authorities";
import { getIsAuthorized } from "../../../utils/authorities";
import CustomerListPage from "../pages/CustomerListPage";
import { Icon } from "@iconify/react";
import NotificationsIcon from "@material-ui/icons/Notifications";

import Location from "../../PrestoExpressLocationApp/pages/Location";
import LoyaltyConfiguration from "../pages/LoyaltyConfiguration";
import StrategyPage from "../pages/StrategyPage";
import RewardListPage from "../pages/RewardListPage";
import BannerListPage from "../pages/BannerListPage";
import ApiKeyPage from "../pages/ApiKeyPage";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import MessageIcon from "@material-ui/icons/Message";
import MessageListPage from "../pages/MessageListPage";
import NotificationMapConfig from "../pages/NotificationMapConfig";
import LogsDetails from "../pages/LogsDetails";
import CustomerDashboardPage from "../pages/CustomerDashboardPage";
import RewardRedeemedReport from "../pages/RewardRedeemedReport";
import RewardChoicesReport from "../pages/RewardChoicesReport";
import RewardCostReport from "../pages/RewardCostReport";

export const getSidebarRoutes = () => {
  const sidebarRoute = [
     {
      id: "Dashboard",
      title: "Dashboard",
      path: "/dashboard",
      icon: <span className="material-symbols-outlined">group</span>,
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },
    {
      id: "CustomerList",
      title: "Customers",
      path: "/customerList",
      icon: <span className="material-symbols-outlined">group</span>,
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },
    {
      id: "StrategyList",
      title: "Loyalty Strategies",
      path: "/strategyList",
      icon: <Icon icon="material-symbols:strategy" height="26" width="26" />,
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },

    {
      id: "RewardList",
      title: "Loyalty Rewards",
      path: "/rewardList",
      icon: (
        <Icon
          icon="material-symbols-light:rewarded-ads"
          height="26"
          width="26"
        />
      ),
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },
    {
      id: "BannerList",
      title: "Loyalty Banners",
      path: "/bannerList",
      icon: (
        <Icon
          icon="material-symbols:planner-banner-ad-pt"
          height="26"
          width="26"
        />
      ),
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },
    {
      id: "messagesList",
      title: "Push Notifications",
      path: "/messages",
      icon: <MessageIcon />,
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },
    {
      id: "rewardRedeemedReport",
      title: "Reward Redemption Report",
      path: "/rewardRedeemedReport",
      icon: <span className="material-symbols-outlined">cards_star</span>,
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },
    {
      id: "rewardChoicesReport",
      title: "Reward Choices Report",
      path: "/rewardChoicesReport",
      icon: (
        <span className="material-symbols-outlined">background_dot_small</span>
      ),
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },
    {
      id: "rewardCostReport",
      title: "Reward Cost Report",
      path: "/rewardCostReport",
      icon: <span className="material-symbols-outlined">loyalty</span>,
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },

    {
      id: "logsDetails",
      title: "Logs",
      path: "/logsDetails",
      icon: <span className="material-symbols-outlined">search_activity</span>,
      isAuthorized: getIsAuthorized(Authorities.CUSTOMER_LIST_READ),
    },

    {
      id: "internal",
      title: "Internal Configurations",
      path: "/internalConfiguration",
      icon: <Icon icon="ri:admin-line" height="24" width="24" />,
      isAuthorized: getIsAuthorized(Authorities.STOCK_CONFIGURATION_READ),
      childRoutes: [
        {
          id: "loyaltyConfiguration",
          title: "Loyalty Configuration",
          path: "/internalConfiguration/loyaltyConfiguration",
          icon: <Icon icon="dashicons:admin-generic" height="24" width="24" />,
          isAuthorized: getIsAuthorized(Authorities.STOCK_CONFIGURATION_READ),
        },
        {
          id: "apiKeyConfiguration",
          title: "API Key Configuration",
          path: "/internalConfiguration/apiKeyConfiguration",
          icon: <LockOpenIcon />,
          isAuthorized: getIsAuthorized(Authorities.STOCK_CONFIGURATION_READ),
        },
        {
          id: "notificationMapConfig",
          title: "Notification Map Config",
          path: "/internalConfiguration/notificationMapConfig",
          icon: <NotificationsIcon />,
          isAuthorized: getIsAuthorized(Authorities.STOCK_CONFIGURATION_READ),
        },
      ],
    },
  ];
  return sidebarRoute;
};
export interface TasksAppRoutesProps {}

const TasksAppRoutes: React.FunctionComponent<TasksAppRoutesProps> = () => {
  return (
    <Switch>
      <Route
        path="/:locationId/presto-customer/dashboard"
        component={CustomerDashboardPage}
        exact
      />
      <Route
        path="/:locationId/presto-customer/customerList"
        component={CustomerListPage}
        exact
      />
      <Route
        path="/:locationId/presto-customer/internalConfiguration/loyaltyConfiguration"
        component={LoyaltyConfiguration}
        exact
      />
      <Route
        path="/:locationId/presto-customer/strategyList"
        component={StrategyPage}
        exact
      />
      <Route
        path="/:locationId/presto-customer/rewardRedeemedReport"
        component={RewardRedeemedReport}
        exact
      />
      <Route
        path="/:locationId/presto-customer/rewardChoicesReport"
        component={RewardChoicesReport}
        exact
      />
      <Route
        path="/:locationId/presto-customer/rewardCostReport"
        component={RewardCostReport}
        exact
      />

      <Route
        path="/:locationId/presto-customer/rewardList"
        component={RewardListPage}
        exact
      />
      <Route
        path="/:locationId/presto-customer/bannerList"
        component={BannerListPage}
        exact
      />
      <Route
        path="/:locationId/presto-customer/messages"
        component={MessageListPage}
        exact
      />
      <Route
        path="/:locationId/presto-customer/logsDetails"
        component={LogsDetails}
        exact
      />

      <Route
        path="/:locationId/presto-customer/internalConfiguration/apiKeyConfiguration"
        component={ApiKeyPage}
        exact
      />

      <Route
        path="/:locationId/presto-customer/internalConfiguration/notificationMapConfig"
        component={NotificationMapConfig}
        exact
      />

      <Route path="/" component={Location} exact />
    </Switch>
  );
};

export default TasksAppRoutes;
